import { Injectable } from '@angular/core';
import {
  AvailabilityHelperService,
  AuthService,
  STOCK_STATUS,
  Availability,
  AvailabilityDisplay,
  ProductService,
  GungAnonymousConfigService,
  Product,
  MetadataService
} from 'gung-standard';
import { DateUtilService, GungLanguageConfigService } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColmecAvailabilityHelperService extends AvailabilityHelperService {
  constructor(
    protected authService: AuthService,
    protected translateService: TranslateService,
    protected productService: ProductService,
    protected dateUtilService: DateUtilService,
    protected gungAnonymousConfigService: GungAnonymousConfigService,
    protected metadataService: MetadataService,
    protected gungLanguageConfigService: GungLanguageConfigService
  ) {
    super(authService, translateService, dateUtilService, gungAnonymousConfigService, metadataService, gungLanguageConfigService);
  }

  public getAvailabilityDisplay(availability: Availability, product: Product = null): Observable<AvailabilityDisplay> {
    return this.productService.getProduct(availability.productId).pipe(
      mergeMap(product => {
        if (false && product.extra._colmecNewProduct) {
          return of({
            value: 'COLMEC_NEW_PRODUCT', // this.translateService.instant('COLMEC_NEW_PRODUCT')
            class: {}
          });
        } else {
          if (!availability) {
            return of({
              value: '',
              class: {
                'd-none': true
              }
            });
          }
          const admin = this.roles.indexOf('ADMIN') > -1;
          const sales = this.roles.indexOf('SALES') > -1;
          const status: STOCK_STATUS =
            availability.currentAvailability > 0
              ? STOCK_STATUS.IN_STOCK
              : availability.maxFutureStock > 0
                ? STOCK_STATUS.INCOMING
                : STOCK_STATUS.OUT_OF_STOCK;

          const value = this.getValueFromStatus(status, sales, availability, product, admin);

          const classVal = this.classSelector(status);

          return of({
            value,
            class: classVal
          });
        }
      })
    );
  }

  protected getValueFromStatus(status: STOCK_STATUS, isSales: boolean, availability: Availability, product?: Product, isAdmin?: boolean): string {
    if (!availability) {
      return '';
    }
    // Don't show 100 000 when leadtime is 0.
    // Contact us for more info and disable add to cart.
    if (availability.currentStock <= 0 && availability.currentAvailability === 100000) {
      return this.translateService.instant('CONTACT_US');
    }

    // SALES + Admin:
    // - Sales should always see the exakt availability.

    // USERS:
    // - Display the exact availability if balance is <25.
    // - If more than 25, display >25
    // - If no availability display (Not in stock - contact us for information)

    // All:
    //  - Future availability (STATUS === INCOMING)) doesn't need to be displayed at this point.

    let value = '';
    if (isAdmin || isSales) {
      if (status === STOCK_STATUS.IN_STOCK) {
        const rounded = Math.round(availability.currentAvailability);
        value = `${this.translateService.instant('IN_STOCK')} (${rounded})`;
      } else if (status === STOCK_STATUS.INCOMING) {
        /* const firstDate = Object.keys(availability.extra.availabilities).filter(key => {
          return availability.extra.availabilities[key] > 0;
        })[0];
        value = this.translateService.instant('EXPECTED_VALUE', { date: firstDate, value: availability.extra.availabilities[firstDate]});
        */
        value = this.translateService.instant('OUT_OF_STOCK');
      } else if (status === STOCK_STATUS.OUT_OF_STOCK) {
        value = this.translateService.instant('OUT_OF_STOCK');
      }
    } else {
      const limit = 50;
      if (status === STOCK_STATUS.IN_STOCK) {
        const valueAvailability =
          availability.currentAvailability > limit ? '>' + limit : Math.round(availability.currentAvailability);
        value = `${this.translateService.instant('IN_STOCK')} (${valueAvailability})`;
      } else if (status === STOCK_STATUS.INCOMING) {
        // value = this.translateService.instant('INCOMING');
        value = this.translateService.instant('USER_AVAILABILITY_OUT_OF_STOCK');
      } else if (status === STOCK_STATUS.OUT_OF_STOCK) {
        value = this.translateService.instant('USER_AVAILABILITY_OUT_OF_STOCK');
      }
    }
    return value;
  }
}
